var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showRoundAlert)?_c('div',{staticClass:"showRoundAlert elimination-round",style:(_vm.alertStyle)},[_vm._v(_vm._s(_vm.$t('Round'))+" "+_vm._s(_vm.current_elimination_round))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }